export default {
  lg: 992,
  desktop: 992,
  mobile: 600,
  largeDesktop: 1050,
  menuBreakpoint: 1050,
};
